import type { ConfigurationQuestion } from './types'
import type { AnswerDraft } from './components/configuration-questions'

export function answerText(question: ConfigurationQuestion, answer: AnswerDraft | undefined, emptyLabel: string) {
    const labels =
        answer?.values.map((value) => question.options.find((option) => option.value === value)?.label ?? value) ?? []

    const text = [answer?.text.trim(), ...labels, answer?.useOther ? answer.other.trim() : '']
        .filter(Boolean)
        .join(', ')

    return text || emptyLabel
}

export function summarizeAnswers(
    questions: ConfigurationQuestion[],
    answers: Record<string, AnswerDraft>,
    emptyLabel: string
) {
    return questions
        .map((question) => `${question.label}: ${answerText(question, answers[question.id], emptyLabel)}`)
        .join('\n')
}
